import React from 'react';

const GuestBrandedThemeWrapper = ({ children, theme }) => (
    <div className={'guest-branded'} style={theme}>
        {children}
    </div>
);

export default GuestBrandedThemeWrapper;
